import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Users } from '../models/users';
import { User } from 'src/app/auth/models/user';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  public REST_API_SERVER:string = `${environment.REST_API_URL}/api/web/${environment.version}`;

  
  constructor(private http:HttpClient) { }

  public getUsers(filterParams):Observable<any>{
    return this.http.get(`${this.REST_API_SERVER}/users`,{params:filterParams,observe:'response'});
  }
  public updateUserStatus(userId: string, isActive: boolean): Observable<any> {
    const url = `${this.REST_API_SERVER}/users/updateuserstatus`;
    const payload = { userId, isActive };
    
    return this.http.post(url, payload, { observe: 'response' });
}

  public getUserById(id:string|number):Observable<any>{
    return this.http.get(`${this.REST_API_SERVER}/users/${id}`,{observe:'response'});
  }

  public createUser(data:Users):Observable<any>{
    return this.http.post(`${this.REST_API_SERVER}/users/createuser`,data,{observe:'response'});
  }

  public updateUser(data:Users):Observable<any>{
    return this.http.post(`${this.REST_API_SERVER}/users/updateuser`,data,{observe:'response'});
  }

  public changeUserData(params:any):Observable<any>{
    return this.http.post(`${this.REST_API_SERVER}/users/changeuserdata`,params);
  }

  public getUsersList(filterParams):Observable<any>{
    return this.http.get(`${this.REST_API_SERVER}/users/userlist`,{params:filterParams,observe:'response'})
  }
  public getReportingList(filterParams):Observable<any>{
    return this.http.get(`${this.REST_API_SERVER}/users/reportinglist`,{params:filterParams,observe:'response'})
  }
  public getReportingListUsers(filterParams):Observable<any>{
    return this.http.get(`${this.REST_API_SERVER}/users/reportinglistusers`,{params:filterParams,observe:'response'})
  }
}
